module.exports = __webpack_public_path__ + "img/acre.d9881cdb.jpg";